<template>
  <div class="head-wrp clear">
    <div class="logo">PEISO</div>
  </div>
</template>

<script>
export default {
  name: 'headcon',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.head-wrp{
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #212429;
  height: 182px;
  z-index: 7;
  box-sizing: border-box;
  padding-left: 30px;
  .logo{
    width: 240px;
    height: 120px;
    float: left;
    color: #fff;
    box-sizing: border-box;
    padding: 48px 0 0 30px;
    font-size: 30px;
    letter-spacing: 10px;
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/headcon.vue